$(document).on('click','.upsell_products .show_me_btn',function(){
  $('.upsell_popup').show();
});

$(document).on('click','.upsell-close-btn, .upsell_popup .popup_overlay',function(){
  $('.upsell_popup').hide();
});

$(document).on('click','.upsell_popup .add_up_btn',function(){
var available_ids = [];
    $('.upsell_popup .up_variant select').each(function(){    
      if($(this).prev('.selected_product').prop("checked") == true){
        var Qty = $(this).next('.upsell-value').val();        
        if(Qty > 0){  
          var variant_id = $(this).val();
          var toPushItem = variant_id+'-'+Qty;
          available_ids.push(toPushItem);
        }      
      }
    });
    for (var i = 0; i < available_ids.length; i++) {
        (function(i){
          setTimeout(function(){
            var formContents = available_ids[i].split('-');            
            var newQty = formContents[1];
            var newVar = formContents[0];
            var params = {
                      type: 'POST',
                      url: '/cart/add.js',
                      data: 'quantity='+newQty+'&id='+newVar,
                      dataType: 'json',
                      success: function(line_item) {                       
                        var iteration_length = i+1;                       
                        if( iteration_length == available_ids.length ){ 
                          document.location.href = '/cart'; 
                        }
                      },
                      error: function() {
                          console.log("fail");
                      }
                  };
            $.ajax(params); 
          }, 1000 * i);
        }(i));  
      }
});

$('.product_upsell_container .selected_product').each(function(){
   $(this).change(function() {
      var numberOfChecked = $('input.selected_product:checkbox:checked').length;
      if(numberOfChecked > 1) {
        $('.add_up_btn').removeClass('disabled');
      }else{
         $('.add_up_btn').addClass('disabled');
      }
    });  
});